module.exports = __webpack_public_path__ + "img/aethir.2cb1dbb3.png";